import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import PutAwayIndexActions, { PutAwayIndexTypes } from '../Stores/PutAwayIndex/Actions';

const getAppStore = state => state.app;

export function* putAwayIndexFetchPutAwayIndex({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PutAwayIndexActions.putAwayIndexFetchPutAwayIndexLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/indexPutAway/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAwayIndexActions.putAwayIndexFetchPutAwayIndexSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayIndexActions.putAwayIndexFetchPutAwayIndexLoading(false));
  }
}

export function* putAwayIndexGoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/putAwayDetail/update/${hdrId}`));
}

export function* putAwayIndexGoToAudit({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/auditResource/PUT_AWAY/${hdrId}/PutAwayHdr`));
}

export function* putAwayIndexResetPutAwaySync01({ hdrIds }) {
  try {
    yield put(PutAwayIndexActions.putAwayIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      divisionId: app.curDivisionId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `putAway/syncProcess/RESET_PUT_AWAY_SYNC_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(PutAwayIndexActions.putAwayIndexResetPutAwaySync01Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayIndexActions.putAwayIndexWorkspaceLoading(false));
  }
}

export function* putAwayIndexResetPutAwayFServ01({ hdrIds }) {
  try {
    yield put(PutAwayIndexActions.putAwayIndexWorkspaceLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      divisionId: app.curDivisionId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `putAway/fServProcess/RESET_PUT_AWAY_F_SERV_01/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(PutAwayIndexActions.putAwayIndexResetPutAwayFServ01Success());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayIndexActions.putAwayIndexWorkspaceLoading(false));
  }
}

export function* putAwayIndexGoToPrint({ document }) {
  try {
    yield put(PutAwayIndexActions.putAwayIndexFetchPutAwayIndexLoading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds: [document.id]
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `putAway/print/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, `PutAway_${document.doc_code}.pdf`);
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayIndexActions.putAwayIndexFetchPutAwayIndexLoading(false));
  }
}

export const saga = [
  takeLatest(PutAwayIndexTypes.PUT_AWAY_INDEX_GO_TO_DOCUMENT, putAwayIndexGoToDocument),
  takeLatest(PutAwayIndexTypes.PUT_AWAY_INDEX_GO_TO_AUDIT, putAwayIndexGoToAudit),
  takeLatest(PutAwayIndexTypes.PUT_AWAY_INDEX_FETCH_PUT_AWAY_INDEX, putAwayIndexFetchPutAwayIndex),

  takeLatest(
    PutAwayIndexTypes.PUT_AWAY_INDEX_RESET_PUT_AWAY_SYNC01,
    putAwayIndexResetPutAwaySync01
  ),
  takeLatest(
    PutAwayIndexTypes.PUT_AWAY_INDEX_RESET_PUT_AWAY_F_SERV01,
    putAwayIndexResetPutAwayFServ01
  ),
  takeLatest(PutAwayIndexTypes.PUT_AWAY_INDEX_GO_TO_PRINT, putAwayIndexGoToPrint)
];
